import type { ContactInfo, NavItem, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { MEDIA } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: "خوزکیمیا زاگرس",
    nameLatin: 'KhuzKimia Zagros',
    tagline: "طبیعت زاگرس، میراث خوزستان، اصالت ایران",
    description: "داروهای گیاهی خودروی کوهستان زاگرس؛ برداشت تخصصی، آنالیز آزمایشگاهی هر محموله، بسته‌بندی بهداشتی و ارسال به کشورهای مختلف جهان.",
    url: getOrigin(),
    ogImage: MEDIA.heroProducts
}

export const contactInfo: ContactInfo = {
    phones: [
        {
            name: "فرزاد ابوالحسنی",
            display: "۰۹۱۷ ۲۳۹ ۳۰۰۴",
            tel: '+989172393004'
        },
        {
            name: "فرشاد امیری",
            display: "۰۹۲۲ ۳۷۳ ۲۳۹۶",
            tel: '+989223732396'
        }
    ],
    whatsapp: {
        display: '+98 917 239 3004',
        url: 'https://wa.me/989172393004'
    },
    telegram: {
        handle: '@KhuzKimiazaghros',
        url: 'https://t.me/KhuzKimiazaghros'
    },
    instagram: {
        handle: '@KhuzKimiazaghros',
        url: 'https://instagram.com/KhuzKimiazaghros'
    },
    eitaa: {
        handle: 'KhuzKimiazaghros',
        url: 'https://eitaa.com/KhuzKimiazaghros'
    },
    email: 'info@khuzkimiazaghros.com',
    address: "ایران، اصفهان، لنجان، زرین‌شهر"
}

export const mainNav: NavItem[] = [
    { label: "خانه", href: '/' },
    { label: "محصولات", href: '/products' },
    { label: "از کوه تا جهان", href: '/process' },
    { label: "صادرات", href: '/export' },
    { label: "درباره ما", href: '/about' },
    { label: "تماس با ما", href: '/contact' }
]
